/* ============================================================
   SpiderLorenzo — comportamiento propio (sin librerías)
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Animaciones de entrada ---------- */
  function initReveals() {
    var items = document.querySelectorAll('.sl-reveal:not(.sl-visible)');
    if (!items.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('sl-visible'); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sl-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    items.forEach(function (el) { obs.observe(el); });
  }

  /* ---------- Galería de producto ---------- */
  function initGaleria() {
    document.querySelectorAll('[data-sl-galeria]').forEach(function (galeria) {
      var main = galeria.querySelector('[data-sl-galeria-main]');
      var thumbs = galeria.querySelectorAll('[data-sl-galeria-thumb]');
      if (!main || !thumbs.length) return;

      function activar(thumb) {
        var full = thumb.getAttribute('data-full');
        if (full) {
          main.src = full;
          main.alt = thumb.getAttribute('data-alt') || '';
        }
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { activar(thumb); });
      });

      galeria.slMostrarMedia = function (mediaId) {
        if (!mediaId) return;
        var match = galeria.querySelector('[data-sl-galeria-thumb][data-media-id="' + mediaId + '"]');
        if (match) activar(match);
      };
    });
  }

  /* ---------- Selector de variantes ---------- */
/* Píldora de demanda: la cifra tiene que seguir a la talla elegida, no quedarse
     con la que se pintó en el servidor. Si la talla nueva tiene mucho stock (o no
     lleva control de stock), la píldora se esconde en vez de mentir. */
  function initDemanda() {
    document.querySelectorAll('[data-sl-producto]').forEach(function (root) {
      var pildora = root.querySelector('[data-sl-demanda]');
      if (!pildora || pildora.getAttribute('data-modo') !== 'stock') return;
      if (pildora.dataset.slListo) return;
      pildora.dataset.slListo = '1';

      var num = pildora.querySelector('[data-sl-demanda-num]');
      var umbral = parseInt(pildora.getAttribute('data-umbral'), 10) || 0;

      root.addEventListener('sl:variante', function (ev) {
        var v = ev.detail;
        if (!v) return;
        var quedan = typeof v.quedan === 'number' ? v.quedan : null;
        if (quedan === null || quedan <= 0 || quedan > umbral) {
          pildora.hidden = true;
          return;
        }
        if (num) num.textContent = 'Quedan ' + quedan;
        pildora.hidden = false;
      });
    });
  }

  /* Carrusel pequeño de opiniones de la ficha.
     No tiene datos propios: los coge de la sección "SL – Opiniones" de la misma página,
     así el dueño escribe cada opinión UNA vez. Por defecto solo pasa las de 5 estrellas. */
  function initMiniOpiniones() {
    var caja = document.querySelector('[data-sl-mini]');
    if (!caja) return;
    /* Candado: sl-scripts.js lo carga cada sección de la página, así que init() se
       ejecuta una vez por sección. Sin esto las tarjetas se apilarían una y otra vez. */
    if (caja.dataset.slListo) return;
    caja.dataset.slListo = '1';

    var fuente = document.querySelector('[data-sl-opiniones-datos]');
    if (!fuente) return;

    var todas;
    try {
      todas = JSON.parse(fuente.textContent);
    } catch (e) {
      return;
    }
    if (!todas || !todas.length) return;

    var soloCinco = caja.getAttribute('data-solo-cinco') !== 'false';
    var lista = todas.filter(function (o) {
      return o && o.texto && (!soloCinco || o.estrellas === 5);
    });
    /* Sin opiniones que enseñar, mejor no enseñar nada que enseñar un hueco */
    if (!lista.length) return;

    var ventana = caja.querySelector('[data-sl-mini-ventana]');
    var intervalo = parseInt(caja.getAttribute('data-intervalo'), 10) || 3500;

    function esc(txt) {
      var d = document.createElement('div');
      d.textContent = txt == null ? '' : txt;
      return d.innerHTML;
    }

    var check =
      '<svg class="sl-mini__check" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
      '<path d="M12 2l2.4 1.8 3-.3 1 2.9 2.6 1.6-1 2.9 1 2.9-2.6 1.6-1 2.9-3-.3L12 22l-2.4-1.8-3 .3-1-2.9L3 16l1-2.9L3 10.2l2.6-1.6 1-2.9 3 .3zm-1 13l5-5-1.4-1.4L11 12.2 9.4 10.6 8 12z"/></svg>';

    var pista = document.createElement('div');
    pista.className = 'sl-mini__pista';

    lista.forEach(function (o, i) {
      var card = document.createElement('article');
      card.className = 'sl-mini__card';

      var avatar = o.foto
        ? '<img class="sl-mini__avatar" src="' + esc(o.foto) + '" alt="" loading="lazy" width="44" height="44">'
        : '<span class="sl-mini__avatar sl-mini__inicial" aria-hidden="true">' +
          esc((o.autor || '?').charAt(0).toUpperCase()) +
          '</span>';

      var estrellas = '';
      for (var e = 0; e < (o.estrellas || 0); e++) estrellas += '★';

      card.innerHTML =
        avatar +
        '<div class="sl-mini__cuerpo">' +
        '<span class="sl-mini__quien">' + esc(o.autor) + (o.verificada ? check : '') + '</span>' +
        '<span class="sl-mini__estrellas" aria-label="' + (o.estrellas || 0) + ' de 5">' + estrellas + '</span>' +
        '<p class="sl-mini__texto">' + esc(o.texto) + '</p>' +
        '</div>';

      pista.appendChild(card);
    });

    ventana.appendChild(pista);

    var cards = pista.querySelectorAll('.sl-mini__card');
    var actual = 0;
    var reloj = null;

    function mostrar(i) {
      actual = (i + cards.length) % cards.length;
      pista.style.transform = 'translateX(-' + actual * 100 + '%)';
      cards.forEach(function (c, n) {
        /* Solo la visible entra en el orden de tabulación y la leen los lectores */
        c.setAttribute('aria-hidden', n === actual ? 'false' : 'true');
      });
    }

    function arrancar() {
      parar();
      if (cards.length < 2) return;
      reloj = setInterval(function () {
        mostrar(actual + 1);
      }, intervalo);
    }
    function parar() {
      if (reloj) clearInterval(reloj);
      reloj = null;
    }

    /* Si el visitante toca una flecha, el reloj se reinicia: nadie quiere que
       la opinión salte medio segundo después de haberla pedido. */
    function paso(dir) {
      mostrar(actual + dir);
      arrancar();
    }

    var prev = caja.querySelector('[data-sl-mini-prev]');
    var next = caja.querySelector('[data-sl-mini-next]');
    if (prev) prev.addEventListener('click', function () { paso(-1); });
    if (next) next.addEventListener('click', function () { paso(1); });

    /* Con el ratón encima se para, para poder leer con calma */
    caja.addEventListener('mouseenter', parar);
    caja.addEventListener('mouseleave', arrancar);
    caja.addEventListener('focusin', parar);
    caja.addEventListener('focusout', arrancar);

    /* Y no gasta tiempo animando si la pestaña está en segundo plano */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) parar(); else arrancar();
    });

    if (cards.length < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
    }

    caja.hidden = false;
    mostrar(0);
    arrancar();
  }

  /* Aviso de últimas unidades: en modo automático tiene que seguir a la talla elegida.
     Si de esa talla hay de sobra (o no se lleva control de stock), se calla. */
  function initUrgencia() {
    document.querySelectorAll('[data-sl-producto]').forEach(function (root) {
      var aviso = root.querySelector('[data-sl-urgencia]');
      if (!aviso || aviso.getAttribute('data-modo') === 'siempre') return;
      if (aviso.dataset.slListo) return;
      aviso.dataset.slListo = '1';

      var umbral = parseInt(aviso.getAttribute('data-umbral'), 10) || 0;

      root.addEventListener('sl:variante', function (ev) {
        var v = ev.detail;
        if (!v) return;
        var quedan = typeof v.quedan === 'number' ? v.quedan : null;
        aviso.hidden = quedan === null || quedan <= 0 || quedan > umbral;
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll('[data-sl-producto]').forEach(function (root) {
      var datos = root.querySelector('[data-sl-variantes]');
      if (!datos) return;

      var variantes;
      try {
        variantes = JSON.parse(datos.textContent);
      } catch (e) {
        return;
      }
      if (!variantes || !variantes.length) return;

      var botones = root.querySelectorAll('[data-sl-opcion]');
      var inputId = root.querySelector('[data-sl-variant-id]');
      var precioActual = root.querySelector('[data-sl-precio]');
      var precioAntes = root.querySelector('[data-sl-precio-antes]');
      var ahorro = root.querySelector('[data-sl-ahorro]');
      var boton = root.querySelector('[data-sl-submit]');
      var barraPrecio = document.querySelector('[data-sl-barra-precio]');
      var galeria = root.querySelector('[data-sl-galeria]');
      var textoDisponible = boton ? boton.getAttribute('data-texto-disponible') : '';
      var textoAgotado = boton ? boton.getAttribute('data-texto-agotado') : '';

      function seleccionActual() {
        var valores = [];
        root.querySelectorAll('[data-sl-grupo]').forEach(function (grupo) {
          var activo = grupo.querySelector('[data-sl-opcion].is-active');
          valores.push(activo ? activo.getAttribute('data-valor') : null);
        });
        return valores;
      }

      function buscarVariante(valores) {
        return variantes.filter(function (v) {
          return valores.every(function (valor, i) {
            return valor === null || v.opciones[i] === valor;
          });
        })[0];
      }

      function pintarEtiqueta(grupo) {
        var etiqueta = grupo.querySelector('[data-sl-valor-activo]');
        var activo = grupo.querySelector('[data-sl-opcion].is-active');
        if (etiqueta && activo) etiqueta.textContent = activo.getAttribute('data-valor');
      }

      function actualizar(variante) {
        if (!variante) return;
        if (inputId) inputId.value = variante.id;

        if (precioActual) precioActual.innerHTML = variante.precio;
        if (precioAntes) {
          if (variante.precio_antes) {
            precioAntes.innerHTML = variante.precio_antes;
            precioAntes.hidden = false;
          } else {
            precioAntes.hidden = true;
          }
        }
        if (ahorro) ahorro.hidden = !variante.descuento;
        if (ahorro && variante.descuento) ahorro.textContent = '-' + variante.descuento + '%';
        if (barraPrecio) barraPrecio.innerHTML = variante.precio;

        if (boton) {
          boton.disabled = !variante.disponible;
          boton.textContent = variante.disponible ? textoDisponible : textoAgotado;
        }

        if (galeria && galeria.slMostrarMedia && variante.media_id) {
          galeria.slMostrarMedia(String(variante.media_id));
        }

        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variante.id);
          window.history.replaceState({}, '', url.toString());
        }

        root.dispatchEvent(new CustomEvent('sl:variante', { detail: variante }));
      }

      /* Tacha los valores (tallas, colores) que no quedan con lo ya elegido */
      function marcarAgotadas() {
        var grupos = root.querySelectorAll('[data-sl-grupo]');
        var actual = seleccionActual();
        grupos.forEach(function (grupo, indice) {
          grupo.querySelectorAll('[data-sl-opcion]').forEach(function (btn) {
            var prueba = actual.slice();
            prueba[indice] = btn.getAttribute('data-valor');
            var hay = variantes.some(function (v) {
              return (
                v.disponible &&
                prueba.every(function (valor, i) {
                  return valor === null || v.opciones[i] === valor;
                })
              );
            });
            btn.classList.toggle('is-soldout', !hay);
            btn.setAttribute('aria-disabled', hay ? 'false' : 'true');
          });
        });
      }

      botones.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var grupo = btn.closest('[data-sl-grupo]');
          if (!grupo) return;
          grupo.querySelectorAll('[data-sl-opcion]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          pintarEtiqueta(grupo);
          actualizar(buscarVariante(seleccionActual()));
          marcarAgotadas();
        });
      });

      root.querySelectorAll('[data-sl-grupo]').forEach(pintarEtiqueta);
      marcarAgotadas();
    });
  }

  /* ---------- Packs con descuento por cantidad ---------- */
  function initPacks() {
    document.querySelectorAll('[data-sl-producto]').forEach(function (root) {
      var contenedor = root.querySelector('[data-sl-packs]');
      var datos = root.querySelector('[data-sl-variantes]');
      var form = root.querySelector('form[action*="/cart/add"]');
      var boton = root.querySelector('[data-sl-submit]');
      if (!contenedor || !datos || !form || !boton) return;

      var variantes;
      try {
        variantes = JSON.parse(datos.textContent);
      } catch (e) {
        return;
      }
      if (!variantes || !variantes.length) return;

      var packs = Array.prototype.slice.call(contenedor.querySelectorAll('[data-sl-pack]'));
      if (!packs.length) return;

      var unaOpcion = contenedor.getAttribute('data-una-opcion') === 'si';
      var formatter;
      try {
        formatter = new Intl.NumberFormat(contenedor.getAttribute('data-idioma') || 'es', {
          style: 'currency',
          currency: contenedor.getAttribute('data-moneda') || 'EUR'
        });
      } catch (e) {
        formatter = null;
      }

      function dinero(centimos) {
        if (formatter) return formatter.format(centimos / 100);
        return (centimos / 100).toFixed(2);
      }

      function variantePorValor(valor) {
        return variantes.filter(function (v) { return v.opciones[0] === valor; })[0];
      }

      function varianteActual() {
        var input = root.querySelector('[data-sl-variant-id]');
        var id = input ? parseInt(input.value, 10) : null;
        return variantes.filter(function (v) { return v.id === id; })[0] || variantes[0];
      }

      /* ---------- Packs mezclados ---------- */
      /* El catálogo permite que cada unidad del pack sea de un modelo distinto.
         El descuento automático de Shopify cuenta unidades de la lista de productos,
         no colores, así que un pack mezclado se lleva la misma rebaja. */
      var catalogoEl = root.querySelector('[data-sl-catalogo]');
      var catalogo = [];
      if (catalogoEl) {
        try { catalogo = JSON.parse(catalogoEl.textContent) || []; } catch (e) { catalogo = []; }
      }
      var mezclar = catalogo.length > 1 && !!contenedor.querySelector('[data-sl-pack-modelo]');

      function productoDe(id) {
        return catalogo.filter(function (p) { return p.id === id; })[0];
      }

      /* Pone las tallas que existen para el modelo elegido, marcando las agotadas */
      function pintarTallas(selTalla, prod, preferida) {
        if (!prod) return;
        var antes = preferida || selTalla.value;
        selTalla.innerHTML = '';
        /* Las tallas se ordenan S -> XXXL, no como vengan del catálogo */
        var escala = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
        var ordenadas = prod.variantes.slice().sort(function (a, b) {
          var ia = escala.indexOf(a.talla);
          var ib = escala.indexOf(b.talla);
          if (ia < 0 || ib < 0) return 0;
          return ia - ib;
        });
        ordenadas.forEach(function (v) {
          var op = document.createElement('option');
          op.value = v.id;
          op.textContent = v.talla + (v.disponible ? '' : ' — agotada');
          op.disabled = !v.disponible;
          selTalla.appendChild(op);
        });
        /* Intenta conservar la talla que ya tenía; si no la hay, la primera disponible */
        var mismaTalla = ordenadas.filter(function (v) {
          return String(v.id) === String(antes) || v.talla === antes;
        })[0];
        var libre = ordenadas.filter(function (v) { return v.disponible; })[0];
        selTalla.value = String((mismaTalla && mismaTalla.disponible ? mismaTalla : libre || ordenadas[0]).id);
      }

      function montarMezcla() {
        if (!mezclar) return;
        var actual = varianteActual();
        var tallaActual = actual ? actual.opciones[0] : null;
        var esteId = parseInt(root.getAttribute('data-producto-id'), 10);

        contenedor.querySelectorAll('[data-sl-pack-unidad]').forEach(function (fila) {
          var selModelo = fila.querySelector('[data-sl-pack-modelo]');
          var selTalla = fila.querySelector('[data-sl-pack-talla]');
          if (!selModelo || !selTalla || selModelo.options.length) return;

          catalogo.forEach(function (prod) {
            var op = document.createElement('option');
            op.value = prod.id;
            op.textContent = prod.titulo;
            selModelo.appendChild(op);
          });
          /* De salida, todas las unidades traen el producto que se está viendo */
          if (productoDe(esteId)) selModelo.value = String(esteId);
          pintarTallas(selTalla, productoDe(parseInt(selModelo.value, 10)), tallaActual);

          selModelo.addEventListener('change', function () {
            selModelo.setAttribute('data-tocado', 'si');
            pintarTallas(selTalla, productoDe(parseInt(selModelo.value, 10)));
            pintarPrecios();
            revisarDisponibilidad();
          });
          selTalla.addEventListener('change', function () {
            selTalla.setAttribute('data-tocado', 'si');
            pintarPrecios();
            revisarDisponibilidad();
          });
          [selModelo, selTalla].forEach(function (sel) {
            sel.addEventListener('click', function (e) { e.stopPropagation(); });
          });
        });
      }

      /* Busca la variante elegida en una fila de pack mezclado */
      function varianteDeFila(fila) {
        var selTalla = fila.querySelector('[data-sl-pack-talla]');
        var selModelo = fila.querySelector('[data-sl-pack-modelo]');
        if (!selTalla || !selModelo) return null;
        var prod = productoDe(parseInt(selModelo.value, 10));
        if (!prod) return null;
        var v = prod.variantes.filter(function (x) { return String(x.id) === selTalla.value; })[0];
        if (!v) return null;
        return { id: v.id, precio_num: v.precio_num, disponible: v.disponible };
      }

      /* Devuelve la lista de variantes elegidas dentro de un pack */
      function unidadesDe(pack) {
        var unidades = parseInt(pack.getAttribute('data-unidades'), 10) || 1;
        var filas = pack.querySelectorAll('[data-sl-pack-unidad]');
        var lista = [];
        if (filas.length) {
          Array.prototype.forEach.call(filas, function (fila) {
            var mezclada = varianteDeFila(fila);
            if (mezclada) {
              lista.push(mezclada);
              return;
            }
            var valores = Array.prototype.map.call(
              fila.querySelectorAll('[data-sl-pack-opcion]'),
              function (sel) { return sel.value; }
            );
            lista.push(porOpciones(valores) || varianteActual());
          });
        } else {
          for (var i = 0; i < unidades; i++) lista.push(varianteActual());
        }
        return lista;
      }

      /* Busca la variante que case con TODOS los valores elegidos */
      function porOpciones(valores) {
        return variantes.filter(function (v) {
          return valores.every(function (valor, i) { return v.opciones[i] === valor; });
        })[0];
      }

      /* Avisa si alguna unidad del pack elegido está agotada */
      function revisarDisponibilidad() {
        var pack = packActivo();
        if (!pack) return true;
        var lista = unidadesDe(pack);
        var todoOk = lista.every(function (v) { return v && v.disponible; });
        var aviso = pack.querySelector('[data-sl-pack-aviso]');
        if (aviso) aviso.hidden = todoOk;
        if (boton) {
          boton.disabled = !todoOk;
          boton.textContent = todoOk ? textoDisponible : textoAgotado;
        }
        return todoOk;
      }

      function pintarPrecios() {
        packs.forEach(function (pack) {
          var desc = parseFloat(pack.getAttribute('data-descuento')) || 0;
          var lista = unidadesDe(pack);
          var bruto = lista.reduce(function (suma, v) { return suma + (v ? v.precio_num : 0); }, 0);
          /* Shopify calcula el descuento unidad por unidad y trunca los céntimos.
             Hay que hacerlo igual o el precio mostrado no cuadra con el del carrito. */
          var rebaja = lista.reduce(function (suma, v) {
            if (!v) return suma;
            return suma + Math.floor((v.precio_num * desc) / 100);
          }, 0);
          var neto = bruto - rebaja;
          var elPrecio = pack.querySelector('[data-sl-pack-precio]');
          var elAntes = pack.querySelector('[data-sl-pack-antes]');
          if (elPrecio) elPrecio.textContent = dinero(neto);
          if (elAntes) elAntes.textContent = desc > 0 ? dinero(bruto) : '';
        });
      }

      function packActivo() {
        return packs.filter(function (p) {
          var radio = p.querySelector('[data-sl-pack-radio]');
          return radio && radio.checked;
        })[0] || packs[0];
      }

      function pintarSeleccion() {
        packs.forEach(function (p) {
          var radio = p.querySelector('[data-sl-pack-radio]');
          p.classList.toggle('is-active', !!(radio && radio.checked));
        });
      }

      /* Al cambiar el color principal, sincroniza los desplegables aún sin tocar */
      function sincronizarColorPrincipal() {
        var actual = varianteActual();
        if (!actual) return;

        /* En los packs mezclados, las filas que el cliente no ha tocado siguen a la
           talla de arriba; las que ya tocó se quedan como las dejó. */
        if (mezclar) {
          contenedor.querySelectorAll('[data-sl-pack-unidad]').forEach(function (fila) {
            var selTalla = fila.querySelector('[data-sl-pack-talla]');
            var selModelo = fila.querySelector('[data-sl-pack-modelo]');
            if (!selTalla || !selModelo) return;
            if (selTalla.getAttribute('data-tocado') === 'si') return;
            if (selModelo.getAttribute('data-tocado') === 'si') return;
            pintarTallas(selTalla, productoDe(parseInt(selModelo.value, 10)), actual.opciones[0]);
          });
          pintarPrecios();
          revisarDisponibilidad();
          return;
        }

        if (!unaOpcion) return;
        packs.forEach(function (pack) {
          pack.querySelectorAll('[data-sl-pack-opcion]').forEach(function (sel) {
            if (sel.getAttribute('data-tocado') !== 'si') sel.value = actual.opciones[0];
          });
        });
        pintarPrecios();
      }

      packs.forEach(function (pack) {
        var radio = pack.querySelector('[data-sl-pack-radio]');
        if (radio) {
          radio.addEventListener('change', function () {
            pintarSeleccion();
            pintarPrecios();
            revisarDisponibilidad();
          });
        }
        pack.querySelectorAll('[data-sl-pack-opcion]').forEach(function (sel) {
          sel.addEventListener('change', function () {
            sel.setAttribute('data-tocado', 'si');
            pintarPrecios();
            revisarDisponibilidad();
          });
          sel.addEventListener('click', function (e) { e.stopPropagation(); });
        });
      });

      root.addEventListener('sl:variante', sincronizarColorPrincipal);

      /* Envío al carrito con varias unidades */
      form.addEventListener('submit', function (e) {
        var pack = packActivo();
        if (!pack) return;
        e.preventDefault();

        var lista = unidadesDe(pack);
        var agrupado = {};
        lista.forEach(function (v) {
          if (!v) return;
          agrupado[v.id] = (agrupado[v.id] || 0) + 1;
        });
        var items = Object.keys(agrupado).map(function (id) {
          return { id: parseInt(id, 10), quantity: agrupado[id] };
        });
        if (!items.length) return;

        var textoOriginal = boton.textContent;
        boton.disabled = true;
        boton.textContent = 'Añadiendo…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart');
            return r.json();
          })
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function () {
            boton.disabled = false;
            boton.textContent = textoOriginal;
            form.submit();
          });
      });

      montarMezcla();
      pintarSeleccion();
      pintarPrecios();
      revisarDisponibilidad();
    });
  }

  /* ---------- Selector de cantidad ---------- */
  function initCantidad() {
    document.querySelectorAll('[data-sl-cantidad]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var paso = btn.getAttribute('data-paso') === 'menos' ? -1 : 1;
          var valor = parseInt(input.value, 10) || 1;
          input.value = Math.max(1, valor + paso);
        });
      });
    });
  }

  /* ---------- Barra de compra fija ---------- */
  function initBarra() {
    var barra = document.querySelector('[data-sl-barra]');
    var referencia = document.querySelector('[data-sl-barra-ref]');
    if (!barra || !referencia || !('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          barra.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    obs.observe(referencia);

    var boton = barra.querySelector('[data-sl-barra-boton]');
    if (boton) {
      boton.addEventListener('click', function (e) {
        e.preventDefault();
        referencia.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      });
    }
  }

  /* ---------- Cabecera: menú móvil, buscador y sombra al bajar ---------- */
  function initHeader() {
    var header = document.querySelector('[data-sl-header]');
    if (!header || header.getAttribute('data-iniciado') === 'si') return;
    header.setAttribute('data-iniciado', 'si');

    /* Sombra en cuanto se separa de arriba */
    var centinela = document.createElement('div');
    centinela.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;';
    document.body.prepend(centinela);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        header.classList.toggle('is-pegada', !entries[0].isIntersecting);
      }).observe(centinela);
    }

    /* Cajón móvil */
    var cajon = document.querySelector('[data-sl-menu]');
    var abrir = header.querySelector('[data-sl-menu-abrir]');
    if (cajon && abrir) {
      function cerrarCajon() {
        cajon.classList.remove('is-abierto');
        abrir.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        setTimeout(function () { cajon.hidden = true; }, 400);
      }
      abrir.addEventListener('click', function () {
        cajon.hidden = false;
        abrir.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        window.requestAnimationFrame(function () { cajon.classList.add('is-abierto'); });
      });
      cajon.querySelectorAll('[data-sl-menu-cerrar]').forEach(function (btn) {
        btn.addEventListener('click', cerrarCajon);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && cajon.classList.contains('is-abierto')) cerrarCajon();
      });
    }

    /* Buscador desplegable */
    var buscador = header.querySelector('[data-sl-buscador]');
    var btnBuscar = header.querySelector('[data-sl-buscar-abrir]');
    if (buscador && btnBuscar) {
      var campo = buscador.querySelector('[data-sl-buscar-input]');
      btnBuscar.addEventListener('click', function () {
        var abierto = !buscador.hidden;
        buscador.hidden = abierto;
        btnBuscar.setAttribute('aria-expanded', abierto ? 'false' : 'true');
        if (!abierto && campo) campo.focus();
      });
      var cerrarBuscar = buscador.querySelector('[data-sl-buscar-cerrar]');
      if (cerrarBuscar) {
        cerrarBuscar.addEventListener('click', function () {
          buscador.hidden = true;
          btnBuscar.setAttribute('aria-expanded', 'false');
        });
      }
    }
  }

  /* ---------- Portada: fotos que se van alternando ---------- */
  function initHeroPila() {
    document.querySelectorAll('[data-sl-hero-pila]').forEach(function (pila) {
      if (pila.getAttribute('data-iniciado') === 'si') return;
      pila.setAttribute('data-iniciado', 'si');

      var fotos = Array.prototype.slice.call(pila.querySelectorAll('.sl-hero__img'));
      if (fotos.length < 2) return;

      var segundos = parseFloat(pila.getAttribute('data-intervalo')) || 5;
      var actual = 0;

      fotos.forEach(function (img, i) {
        img.classList.toggle('is-visible', i === 0);
      });

      setInterval(function () {
        if (document.hidden) return;
        fotos[actual].classList.remove('is-visible');
        actual = (actual + 1) % fotos.length;
        fotos[actual].classList.add('is-visible');
      }, segundos * 1000);
    });
  }

  /* ---------- Carrusel de vídeos de clientes ---------- */
  function initUgc() {
    document.querySelectorAll('[data-sl-ugc]').forEach(function (raiz) {
      if (raiz.getAttribute('data-iniciado') === 'si') return;
      raiz.setAttribute('data-iniciado', 'si');

      var track = raiz.querySelector('[data-sl-ugc-track]');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('[data-sl-ugc-card]'));
      if (!cards.length) return;

      var prev = raiz.querySelector('[data-sl-ugc-prev]');
      var next = raiz.querySelector('[data-sl-ugc-next]');
      var seccion = raiz.closest('.sl-ugc') || raiz.parentNode;
      var puntos = seccion ? seccion.querySelector('[data-sl-ugc-puntos]') : null;

      /* Reproducción: solo un vídeo a la vez */
      cards.forEach(function (card) {
        var video = card.querySelector('[data-sl-ugc-video]');
        var play = card.querySelector('[data-sl-ugc-play]');
        if (!video || !play) return;

        play.addEventListener('click', function () {
          cards.forEach(function (otra) {
            var otroVideo = otra.querySelector('[data-sl-ugc-video]');
            if (otroVideo && otroVideo !== video) {
              otroVideo.pause();
              otroVideo.removeAttribute('controls');
              otra.classList.remove('is-playing');
            }
          });
          video.setAttribute('controls', '');
          card.classList.add('is-playing');
          var intento = video.play();
          if (intento && intento.catch) {
            intento.catch(function () {
              video.muted = true;
              video.play().catch(function () {});
            });
          }
        });

        video.addEventListener('pause', function () {
          if (video.currentTime === 0 || video.ended) card.classList.remove('is-playing');
        });
        video.addEventListener('ended', function () {
          card.classList.remove('is-playing');
          video.removeAttribute('controls');
        });
      });

      /* Puntitos */
      if (puntos) {
        puntos.innerHTML = '';
        cards.forEach(function (card, i) {
          var punto = document.createElement('button');
          punto.type = 'button';
          punto.className = 'sl-ugc__punto' + (i === 0 ? ' is-active' : '');
          punto.setAttribute('aria-label', 'Ir al vídeo ' + (i + 1));
          punto.addEventListener('click', function () { irA(i); });
          puntos.appendChild(punto);
        });
      }

      function indiceVisible() {
        var centro = track.scrollLeft + track.clientWidth / 2;
        var mejor = 0;
        var minima = Infinity;
        cards.forEach(function (card, i) {
          var medio = card.offsetLeft + card.offsetWidth / 2;
          var d = Math.abs(medio - centro);
          if (d < minima) { minima = d; mejor = i; }
        });
        return mejor;
      }

      function irA(i) {
        var card = cards[Math.max(0, Math.min(cards.length - 1, i))];
        if (!card) return;
        track.scrollTo({
          left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2,
          behavior: reduced ? 'auto' : 'smooth'
        });
      }

      function refrescar() {
        var i = indiceVisible();
        if (puntos) {
          Array.prototype.forEach.call(puntos.children, function (p, j) {
            p.classList.toggle('is-active', j === i);
          });
        }
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      }

      if (prev) prev.addEventListener('click', function () { irA(indiceVisible() - 1); });
      if (next) next.addEventListener('click', function () { irA(indiceVisible() + 1); });

      var esperando = false;
      track.addEventListener('scroll', function () {
        if (esperando) return;
        esperando = true;
        window.requestAnimationFrame(function () {
          refrescar();
          esperando = false;
        });
      });
      window.addEventListener('resize', refrescar);
      refrescar();
    });
  }

  /* ---------- Contador de oferta ---------- */
  function initContador() {
    document.querySelectorAll('[data-sl-contador]').forEach(function (barra) {
      if (barra.getAttribute('data-iniciado') === 'si') return;
      barra.setAttribute('data-iniciado', 'si');

      var modo = barra.getAttribute('data-modo') || 'diario';
      var mostrarDias = barra.getAttribute('data-mostrar-dias') === 'si';
      var elDias = barra.querySelector('[data-sl-dias]');
      var elHoras = barra.querySelector('[data-sl-horas]');
      var elMinutos = barra.querySelector('[data-sl-minutos]');
      var elSegundos = barra.querySelector('[data-sl-segundos]');

      function objetivo() {
        if (modo === 'fecha') {
          var texto = (barra.getAttribute('data-fecha') || '').trim();
          if (!texto) return null;
          /* Acepta "AAAA-MM-DD HH:MM" y "AAAA-MM-DD" */
          var fecha = new Date(texto.replace(' ', 'T'));
          if (isNaN(fecha.getTime())) fecha = new Date(texto);
          return isNaN(fecha.getTime()) ? null : fecha;
        }
        /* Modo diario: medianoche de hoy en la hora del visitante */
        var medianoche = new Date();
        medianoche.setHours(24, 0, 0, 0);
        return medianoche;
      }

      function dosDigitos(n) { return n < 10 ? '0' + n : String(n); }

      function pintar() {
        var fin = objetivo();
        if (!fin) return;
        var restante = fin.getTime() - Date.now();

        if (restante <= 0) {
          if (modo === 'fecha') {
            barra.hidden = true;
            return;
          }
          restante = 0;
        }

        var seg = Math.floor(restante / 1000);
        var dias = Math.floor(seg / 86400);
        var horas = Math.floor((seg % 86400) / 3600);
        var minutos = Math.floor((seg % 3600) / 60);
        var segundos = seg % 60;

        if (!mostrarDias && dias > 0) horas += dias * 24;

        if (elDias) elDias.textContent = dosDigitos(dias);
        if (elHoras) elHoras.textContent = dosDigitos(horas);
        if (elMinutos) elMinutos.textContent = dosDigitos(minutos);
        if (elSegundos) elSegundos.textContent = dosDigitos(segundos);
      }

      pintar();
      setInterval(pintar, 1000);
    });
  }

  /* ---------- Copiar código de descuento ---------- */
  function initCopiar() {
    document.querySelectorAll('[data-sl-copiar]').forEach(function (btn) {
      if (btn.getAttribute('data-iniciado') === 'si') return;
      btn.setAttribute('data-iniciado', 'si');

      btn.addEventListener('click', function () {
        var codigo = btn.getAttribute('data-sl-copiar') || '';
        var etiqueta = btn.querySelector('[data-sl-copiar-texto]');
        var original = etiqueta ? etiqueta.textContent : '';

        function avisar() {
          if (!etiqueta) return;
          btn.classList.add('is-copiado');
          etiqueta.textContent = '¡Copiado!';
          setTimeout(function () {
            etiqueta.textContent = original;
            btn.classList.remove('is-copiado');
          }, 1800);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo).then(avisar, function () {});
          return;
        }
        var tmp = document.createElement('textarea');
        tmp.value = codigo;
        tmp.setAttribute('readonly', '');
        tmp.style.position = 'absolute';
        tmp.style.left = '-9999px';
        document.body.appendChild(tmp);
        tmp.select();
        try { document.execCommand('copy'); avisar(); } catch (e) {}
        document.body.removeChild(tmp);
      });
    });
  }

  /* ---------- Ticker: duplica el contenido para bucle infinito ---------- */
  function initTicker() {
    document.querySelectorAll('[data-sl-ticker]').forEach(function (track) {
      if (track.getAttribute('data-clonado') === 'si') return;
      track.innerHTML = track.innerHTML + track.innerHTML;
      track.setAttribute('data-clonado', 'si');
    });
  }


  /* ---------- Catálogo de la portada: elegir talla y al carrito ---------- */
  function initCatalogo() {
    document.querySelectorAll('[data-sl-cat-card]').forEach(function (card) {
      if (card.getAttribute('data-iniciado') === 'si') return;
      card.setAttribute('data-iniciado', 'si');

      var abrir = card.querySelector('[data-sl-cat-abrir]');
      var caja = card.querySelector('[data-sl-cat-tallas]');
      var anadir = card.querySelector('[data-sl-cat-anadir]');
      if (!abrir || !caja || !anadir) return;

      var elegida = null;
      var textoAbrir = abrir.textContent;
      var textoAnadir = anadir.textContent;

      abrir.addEventListener('click', function () {
        var cerrada = caja.hidden;
        /* solo un selector abierto a la vez en toda la rejilla */
        document.querySelectorAll('[data-sl-cat-tallas]').forEach(function (o) {
          if (o !== caja) o.hidden = true;
        });
        caja.hidden = !cerrada;
        if (!caja.hidden) {
          var libre = caja.querySelector('[data-sl-cat-talla]:not([disabled])');
          if (libre) libre.focus();
        }
      });

      caja.querySelectorAll('[data-sl-cat-talla]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          caja.querySelectorAll('[data-sl-cat-talla]').forEach(function (b) {
            b.classList.toggle('is-sel', b === btn);
          });
          elegida = btn.getAttribute('data-variante');
          anadir.disabled = !elegida;
        });
      });

      anadir.addEventListener('click', function () {
        if (!elegida) return;
        anadir.disabled = true;
        anadir.textContent = 'Añadiendo…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(elegida, 10), quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart');
            return r.json();
          })
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function () {
            /* si algo falla, que al menos llegue a la ficha del producto */
            var url = card.getAttribute('data-url');
            if (url) window.location.href = url;
            else {
              anadir.disabled = false;
              anadir.textContent = textoAnadir;
            }
          });
      });
    });

    /* cerrar los selectores al pulsar fuera */
    if (!document.body.hasAttribute('data-sl-cat-global')) {
      document.body.setAttribute('data-sl-cat-global', 'si');
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-sl-cat-compra]')) return;
        document.querySelectorAll('[data-sl-cat-tallas]').forEach(function (o) { o.hidden = true; });
      });
    }
  }

  function init() {
    /* Cada pieza va aislada: si una falla, las demás siguen funcionando */
    [
      initHeader,
      initCatalogo,
      initReveals,
      initHeroPila,
      initContador,
      initCopiar,
      initTicker,
      initUgc,
      initGaleria,
      initVariantes,
      initDemanda,
      initMiniOpiniones,
      initUrgencia,
      initPacks,
      initCantidad,
      initBarra
    ].forEach(function (fn) {
      try {
        fn();
      } catch (e) {
        if (window.console && console.warn) console.warn('[SL] fallo en ' + fn.name, e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Reinicializa dentro del editor de Shopify */
  document.addEventListener('shopify:section:load', init);
})();
